var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "my__projects" } },
    [
      _c("HeaderControlsProject", {
        attrs: { myWeek: false, namespace: _vm.namespace }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-fluid" },
        [_c("MyProjectsList", { attrs: { namespace: _vm.namespace } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }